"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToMarginPositionEvents = exports.requestOpenPositions = exports.requestClosedPositions = exports.repayMarginPosition = exports.receiveRepaymentAssetOptions = exports.receiveOpenPositions = exports.receiveClosedPositions = exports.getRepaymentAssetOptions = exports.getOpenPositions = exports.getClosedPositions = exports.closeMarginPosition = exports.cancelMarginPosition = exports.UPDATE_POSITION = exports.REQUEST_OPEN_POSITIONS = exports.REQUEST_MARGIN_POSITIONS_PAYMENTS = exports.REQUEST_CLOSED_POSITIONS = exports.RECEIVE_REPAYMENT_ASSET_OPTIONS = exports.RECEIVE_OPEN_POSITIONS = exports.RECEIVE_CLOSED_POSITIONS = exports.GetEstimatedAmountForClosePositionBySettlement = void 0;
var _apiActions = require("../../actions/apiActions");
var _snackbarActions = require("../../actions/snackbarActions");
var _MarginPositionSubscriptionService = _interopRequireDefault(require("../services/MarginPositionSubscriptionService"));
var _selectors = require("../selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var REQUEST_OPEN_POSITIONS = exports.REQUEST_OPEN_POSITIONS = 'REQUEST_OPEN_POSITIONS';
var REQUEST_CLOSED_POSITIONS = exports.REQUEST_CLOSED_POSITIONS = 'REQUEST_CLOSED_POSITIONS';
var REQUEST_MARGIN_POSITIONS_PAYMENTS = exports.REQUEST_MARGIN_POSITIONS_PAYMENTS = 'REQUEST_MARGIN_POSITIONS_PAYMENTS';
var RECEIVE_OPEN_POSITIONS = exports.RECEIVE_OPEN_POSITIONS = 'RECEIVE_OPEN_POSITIONS';
var RECEIVE_CLOSED_POSITIONS = exports.RECEIVE_CLOSED_POSITIONS = 'RECEIVE_CLOSED_POSITIONS';
var UPDATE_POSITION = exports.UPDATE_POSITION = 'UPDATE_POSITION';
var RECEIVE_REPAYMENT_ASSET_OPTIONS = exports.RECEIVE_REPAYMENT_ASSET_OPTIONS = 'RECEIVE_REPAYMENT_ASSET_OPTIONS';
var getOpenPositions = exports.getOpenPositions = function getOpenPositions(AccountId, OMSId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch) {
      var positions;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            dispatch(requestOpenPositions());
            _context.next = 4;
            return dispatch((0, _apiActions.callAPI)('GetMarginPositions', {
              omsId: OMSId,
              accountId: AccountId
            }));
          case 4:
            positions = _context.sent;
            if (positions.length === 0 || positions.length > 0) {
              dispatch(receiveOpenPositions(positions));
            } else {
              console.error('GetMarginPositionStates error: ', positions.errormsg);
            }
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.error('GetMarginPositionStates error: ', _context.t0);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getClosedPositions = exports.getClosedPositions = function getClosedPositions(AccountId, OMSId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch) {
      var positions;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            dispatch(requestClosedPositions());
            _context2.next = 4;
            return dispatch((0, _apiActions.callAPI)('GetMarginPositionHistory', {
              omsId: OMSId,
              accountId: AccountId
            }));
          case 4:
            positions = _context2.sent;
            if (positions.length === 0 || positions.length > 0) {
              dispatch(receiveClosedPositions(positions));
            } else {
              console.error('GetMarginPositionHistory error: ', positions.errormsg);
            }
            _context2.next = 11;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            console.error('GetMarginPositionHistory error: ', _context2.t0);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 8]]);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var subscribeToMarginPositionEvents = exports.subscribeToMarginPositionEvents = function subscribeToMarginPositionEvents(AccountId) {
  return function (dispatch) {
    _MarginPositionSubscriptionService["default"].subscribe(function (position) {
      if (position.PositionState === 'Open' && position.ChangeReason === 'UnableToClose') {
        dispatch((0, _snackbarActions.showSnack)({
          id: 'unableToClosePositionErrorSnack',
          text: "Position ".concat(position.BaseProductSymbol).concat(position.QuoteProductSymbol, " could not be closed. There is still an outstanding liability, please verify and try again."),
          type: 'warning'
        }));
      }
      if (position.PositionState === 'Closed' && (position.ChangeReason === 'CloseOperation' || position.ChangeReason === 'SoldToClose' || position.ChangeReason === 'BoughtToClose')) {
        dispatch((0, _snackbarActions.showSnack)({
          id: 'closePositionSuccessSnack',
          text: "Position ".concat(position.BaseProductSymbol).concat(position.QuoteProductSymbol, " closed"),
          type: 'success'
        }));
      }
      if (position.ChangeReason === 'UnableToRepay') {
        dispatch((0, _snackbarActions.showSnack)({
          id: 'unableToFullyRepayPositionErrorSnack',
          text: 'There was a problem trying to repay the specified amount with the selected assets. Please try again.',
          type: 'warning'
        }));
      }
      if (position.ChangeReason === 'Repaid') {
        dispatch((0, _snackbarActions.showSnack)({
          id: 'repayPositionSuccessSnack',
          text: "Your ".concat(position.BaseProductSymbol).concat(position.QuoteProductSymbol, " ").concat(position.PositionType, " position has been repaid successfully."),
          type: 'success'
        }));
      }
      if (position.AccountId === AccountId) {
        dispatch({
          type: UPDATE_POSITION,
          payload: position
        });
      }
    });
  };
};
var requestOpenPositions = exports.requestOpenPositions = function requestOpenPositions() {
  return {
    type: REQUEST_OPEN_POSITIONS
  };
};
var requestClosedPositions = exports.requestClosedPositions = function requestClosedPositions() {
  return {
    type: REQUEST_CLOSED_POSITIONS
  };
};
var receiveOpenPositions = exports.receiveOpenPositions = function receiveOpenPositions(payload) {
  return {
    type: RECEIVE_OPEN_POSITIONS,
    payload: payload
  };
};
var receiveClosedPositions = exports.receiveClosedPositions = function receiveClosedPositions(payload) {
  return {
    type: RECEIVE_CLOSED_POSITIONS,
    payload: payload
  };
};
var closeMarginPosition = exports.closeMarginPosition = function closeMarginPosition(_ref3, RepaymentAssets) {
  var AccountId = _ref3.AccountId,
    PositionId = _ref3.PositionId,
    PositionInstrumentId = _ref3.PositionInstrumentId;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return dispatch((0, _apiActions.callAPI)('CloseMarginPosition', {
              AccountId: AccountId,
              PositionId: PositionId,
              PositionInstrumentId: PositionInstrumentId,
              RepaymentAssets: RepaymentAssets
            })).then(function (res) {
              if (res.status !== 'Accepted') {
                dispatch((0, _snackbarActions.showSnack)({
                  id: 'closeOpenPositionsErrorSnack',
                  text: "".concat(res.errormsg),
                  type: 'warning'
                }));
              }
            });
          case 2:
            return _context3.abrupt("return", _context3.sent);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var cancelMarginPosition = exports.cancelMarginPosition = function cancelMarginPosition(_ref5) {
  var AccountId = _ref5.AccountId,
    PositionId = _ref5.PositionId,
    PositionInstrumentId = _ref5.PositionInstrumentId,
    PositionType = _ref5.PositionType,
    instrument = _ref5.instrument;
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return dispatch((0, _apiActions.callAPI)('CancelMarginPosition', {
              AccountId: AccountId,
              PositionId: PositionId,
              PositionInstrumentId: PositionInstrumentId
            })).then(function (res) {
              if (res.status === 'Accepted') {
                dispatch((0, _snackbarActions.showSnack)({
                  id: 'cancelOpenPositionsSuccessSnack',
                  text: "Your ".concat(PositionType, " ").concat(instrument.Symbol, " position has been cancelled succesfully."),
                  type: 'success'
                }));
              } else {
                dispatch((0, _snackbarActions.showSnack)({
                  id: 'cancelOpenPositionsErrorSnack',
                  text: "There was an error cancelling your ".concat(PositionType, " ").concat(instrument.Symbol, " position. Error Details: ").concat(res.errormsg),
                  type: 'warning'
                }));
              }
            });
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var GetEstimatedAmountForClosePositionBySettlement = exports.GetEstimatedAmountForClosePositionBySettlement = function GetEstimatedAmountForClosePositionBySettlement(OrderId, InstrumentId) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var OMSId, _marginAccountSelecto, AccountId;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            _marginAccountSelecto = (0, _selectors.marginAccountSelector)(getState()), AccountId = _marginAccountSelecto.AccountId;
            _context5.next = 4;
            return dispatch((0, _apiActions.callAPI)('GetEstimatedAmountForClosePositionBySettlement', {
              OMSId: OMSId,
              AccountId: AccountId,
              OrderId: OrderId,
              InstrumentId: InstrumentId
            }));
          case 4:
            return _context5.abrupt("return", _context5.sent);
          case 5:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var receiveRepaymentAssetOptions = exports.receiveRepaymentAssetOptions = function receiveRepaymentAssetOptions(payload) {
  return {
    type: RECEIVE_REPAYMENT_ASSET_OPTIONS,
    payload: payload
  };
};
var getRepaymentAssetOptions = exports.getRepaymentAssetOptions = function getRepaymentAssetOptions(PositionId) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch, getState) {
      var OMSId, _marginAccountSelecto2, AccountId, repaymentAssetOptions;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            OMSId = getState().user.userInfo.OMSId;
            _marginAccountSelecto2 = (0, _selectors.marginAccountSelector)(getState()), AccountId = _marginAccountSelecto2.AccountId;
            _context6.next = 5;
            return dispatch((0, _apiActions.callAPI)('GetRepaymentAssetOptions', {
              OMSId: OMSId,
              AccountId: AccountId,
              PositionId: PositionId
            }));
          case 5:
            repaymentAssetOptions = _context6.sent;
            if (repaymentAssetOptions.length === 0 || repaymentAssetOptions.length > 0) {
              dispatch(receiveRepaymentAssetOptions(repaymentAssetOptions));
            }
            _context6.next = 12;
            break;
          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](0);
            console.error('GetRepaymentAssetOptions error: ', _context6.t0);
          case 12:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[0, 9]]);
    }));
    return function (_x7, _x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var repayMarginPosition = exports.repayMarginPosition = function repayMarginPosition(_ref9) {
  var AccountId = _ref9.AccountId,
    PositionId = _ref9.PositionId,
    PositionInstrumentId = _ref9.PositionInstrumentId,
    PercentageToRepay = _ref9.PercentageToRepay,
    RepaymentAssets = _ref9.RepaymentAssets,
    Instrument = _ref9.Instrument,
    PositionType = _ref9.PositionType;
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch) {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return dispatch((0, _apiActions.callAPI)('RepayMarginPosition', {
              AccountId: AccountId,
              PositionId: PositionId,
              PositionInstrumentId: PositionInstrumentId,
              PercentageToRepay: PercentageToRepay,
              RepaymentAssets: RepaymentAssets
            })).then(function (res) {
              if (res.status !== 'Accepted') {
                dispatch((0, _snackbarActions.showSnack)({
                  id: 'repayPositionErrorSnack',
                  text: "There was an error repaying your ".concat(PositionType, " ").concat(Instrument.Symbol, " position. Error Details: ").concat(res.errormsg),
                  type: 'warning'
                }));
              }
            });
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x9) {
      return _ref10.apply(this, arguments);
    };
  }();
};